export class EmailItineraryProperties {

  customerName: string;

  customerEmail: string;

  subject: string;

  body: string;
  includeAllResults: boolean=false;

}


export class TicketEmailProperties {


  customerEmail: string;

  subject: string;

  body: string;

}
